<template>

</template>
<script>
export default{
    data(){
        return{

        }
    },
    created(){
        this.authorizedLogin()
    },
    methods:{
        authorizedLogin(){
            console.log('开始执行')
            window.location.href = "https://monkeyshop.mangkeyi.com/acc/oidc-authorize?response_type=code&client_id=62154d6bae138725a22b&redirect_uri=http://localhost:8080&scope=openid email";
            console.log('执行结束')
        }
    }
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/login.vue